module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "OregonState.d8fce284.webp";